export default __webpack_public_path__ + "static/media/58_mobile.524cd859.jpg";